"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line import/prefer-default-export
exports.Wrapper = styled_components_1.default.div `
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
  padding: 0 24px 24px;
  margin: 24px;

  background: white;
  box-sizing: border-box;
  width: 410px;
  border: 1px solid black;
  border-radius: 6px;
  overflow: hidden;
`;
//# sourceMappingURL=styled.js.map